<template>
  <div>
    <el-carousel height="500px" direction="vertical">
      <el-carousel-item v-for="(item, index) in slideList" :key="index">
        <img :src="item.img_src" alt="" class="carousel-img" />
      </el-carousel-item>
    </el-carousel>
    <!-- 全部 -->
    <div class="entire">
      <div class="entire-first">
        <div class="entire-first-text">
          <div> {{ $t("locale.release") }}</div>
          <div>
            <i class="el-icon-caret-left" @click="btnEmtireLeft"></i>
            <i class="el-icon-caret-right" @click="btnEmtireRight"></i>
          </div>
        </div>
        <div class="entire-first-img" ref="tabContainer">
          <div
            v-for="(item, index) in serverList"
            :key="index"
            class="entire-first-img-for"
            @mouseleave="mouseleave(index)"
            @mouseenter="mouseenter(index)"
            @click="btnvideo(item)"
          >
            <img class="entire-first-img-tu" :src="item.img" alt="" />
            <div class="posont" v-if="showImg == index">
              <i class="el-icon-caret-right"></i>
            </div>
            <div class="entire-first-img-text">{{ item.name }}</div>
            <!-- <div class="entire-first-img-one">
              <span style="color: #d5495b; margin-right: 5px">EP.12</span>/
              <span style="margin-left: 5px">EP.12</span>
            </div> -->
          </div>
        </div>
      </div>

      <div class="entire-first">
        <div class="entire-first-text">{{ $t("locale.now") }}</div>
        <div class="entire-first-comm">
          <div
            v-for="(item, index) in overallList"
            :key="index"
            class="entire-first-img-ended"
            @click="btnvideocomm(item)"
            @mouseleave="mouseover(index)"
            @mouseenter="enteover(index)"
          >
            <img class="entire-first-img-tu" :src="item.img" alt="" />
            <div class="posont" v-if="overaImg == index">
              <i class="el-icon-caret-right"></i>
            </div>
            <div class="entire-first-img-text hidden">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="movies" @click="btnmovies" v-if="overallPage > 9">
         {{ $t("locale.Movies") }}
        </div>
        <div class="moviesto" @click="btnmovies" v-else>
        {{ $t("locale.More") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { slideshow, server, overall } from "@/api/user";
export default {
  name: "Logins",
  data() {
    return {
      // 轮播图
      slideList: [],
      // 流行数据
      serverList: [],
      // 全部数据
      overallList: [],
      page: 1,
      overallPage: 0,
      overaImg: 999,

      showImg: 999,
      scrollStep: 0, // 每次滚动的距离，100px
      scrollPosition: 0, // 当前滚动的位置
      tabOffsetWidth: 0, // 元素的可见宽度，包括元素的内容宽度、内边距和边框宽度
      tabScrollWidth: 0, // 元素的内容宽度，包括被隐藏的部分
      tabClientWidth: 0, // 元素的可见宽度，不包括滚动条和边框的宽度
    };
  },
  mounted() {
    this.scrollStep = window.innerWidth;
    this.tabOffsetWidth = this.$refs.tabContainer.offsetWidth;
    this.tabScrollWidth = this.$refs.tabContainer.scrollWidth;
    this.tabClientWidth = this.$refs.tabContainer.clientWidth;
    // console.log(this.tabOffsetWidth, this.tabClientWidth, this.tabScrollWidth);

    this.slide();
    this.over();
  },

  methods: {
    // 轮播图
    slide() {
      slideshow().then((res) => {
        // 轮播图
        this.slideList = res.banner;
        // console.log(res.banner);
      });
      // 流行数据
      server().then((res) => {
        this.serverList = res.new;
      });
    },
    over() {
      // 全部数据
      overall({
        page: this.page,
        limit: 10,
      }).then((res) => {
        this.overallPage = res.data.length;
        this.overallList = [...this.overallList, ...res.data];
        // console.log("全部数据", this.overallList);
      });
    },
    // 加载下一页
    btnmovies() {
      if (this.overallPage != 0) {
        this.page++;
        this.over();
      }
    },
    // 阴影
    mouseleave(index) {
      this.showImg = 999;
    },
    mouseenter(index) {
      this.showImg = index;
    },
    mouseover(index) {
      this.overaImg = 999;
    },
    enteover(index) {
      this.overaImg = index;
    },
    btnEmtireLeft() {
      if (this.scrollPosition > 0) {
        this.scrollPosition -= this.scrollStep;
        this.$refs.tabContainer.scrollTo({
          left: this.scrollPosition,
          behavior: "smooth",
        });
      }
    },

    btnEmtireRight() {
      if (
        this.scrollPosition <
        this.$refs.tabContainer.scrollWidth - this.tabOffsetWidth
      ) {
        this.scrollPosition += this.scrollStep;
        this.$refs.tabContainer.scrollTo({
          left: this.scrollPosition,
          behavior: "smooth",
        });
      }
    },
    btnvideo(data) {
      this.$router.push(`/video?videoId=${data.id}`);
    },
    btnvideocomm(data) {
      this.$router.push(`/video?videoId=${data.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-img {
  width: 100%;
  height: inherit;
  overflow: hidden; //img如果超出这个div会隐藏超出部分
  display: flex; //flex布局
  align-items: center;
  object-fit: cover;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 400px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.entire {
  padding: 0 120px;
}
.entire-first {
  margin-top: 40px;
}
.entire-first-text {
  font-size: 18px;
  font-weight: 900;
  display: flex;
  justify-content: space-between;
}
.entire-first-img {
  margin-top: 20px;
  display: flex;
  overflow: hidden;
  // flex-wrap: wrap;
}

.entire-first-img-tu {
  width: 190px;
  height: 300px;
  border-radius: 5px;
  object-fit: cover;
  transition: transform 0.3s;
}
.entire-first-img-ended:hover img {
  transform: scale(1.05);
}
.entire-first-img-for:hover img {
  transform: scale(1.05);
}
.entire-first-img-for {
  width: 200px;
  position: relative;
    cursor: pointer;
  // overflow: hidden;
  margin-right: 10px;
}
.posont {
  position: absolute;
  top: 0;
  left: 0;

  width: 210px;
  height: 300px;
  text-align: center;
  line-height: 300px;
  font-size: 36px;
}
.entire-first-img-text {
  margin-top: 10px;
  font-weight: 700;
}
.entire-first-img-one {
  margin-top: 10px;
  font-size: 12px;
  color: #7d7d7d;
}
.entire-first-comm {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}
.entire-first-img-ended {
  width: 190px;
  position: relative;
  cursor: pointer;

  // overflow: hidden;
  margin-right: 10px;
}
.hidden {
  margin-bottom: 10px;
}
.movies {
  width: 300px;
  height: 50px;
  border: 1px solid #3f3f3f;
  margin: 40px auto;
  text-align: center;
  line-height: 50px;
  border-radius: 10px;
  background-color: #0f0f0f;
}
.moviesto {
  width: 300px;
  height: 50px;

  margin: 40px auto;
  text-align: center;
  line-height: 50px;
  border-radius: 10px;
}
</style>